// proto/v2/recordings/recordings.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file recordings/recordings.proto (package lvdr.v2.recordings, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file recordings/recordings.proto.
 */
export const file_recordings_recordings: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * TranscriptSegment is one ASR-emitted span over the audio timeline. Speaker
 * and text are adversary-controlled (ASR over user audio); callers that
 * persist these strings must sanitize + length-cap them — the orchestrator
 * (internal/recordings) is the canonical sanitiser.
 *
 * @generated from message lvdr.v2.recordings.TranscriptSegment
 */
export type TranscriptSegment = Message<"lvdr.v2.recordings.TranscriptSegment"> & {
  /**
   * @generated from field: double start_secs = 1;
   */
  startSecs: number;

  /**
   * @generated from field: double end_secs = 2;
   */
  endSecs: number;

  /**
   * @generated from field: string speaker = 3;
   */
  speaker: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;
};

/**
 * Describes the message lvdr.v2.recordings.TranscriptSegment.
 * Use `create(TranscriptSegmentSchema)` to create a new message.
 */
export const TranscriptSegmentSchema: GenMessage<TranscriptSegment> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 0);

/**
 * @generated from message lvdr.v2.recordings.Transcript
 */
export type Transcript = Message<"lvdr.v2.recordings.Transcript"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: repeated lvdr.v2.recordings.TranscriptSegment segments = 2;
   */
  segments: TranscriptSegment[];

  /**
   * @generated from field: string language = 3;
   */
  language: string;

  /**
   * @generated from field: string model = 4;
   */
  model: string;
};

/**
 * Describes the message lvdr.v2.recordings.Transcript.
 * Use `create(TranscriptSchema)` to create a new message.
 */
export const TranscriptSchema: GenMessage<Transcript> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 1);

/**
 * Recording mirrors internal/recordings.Recording on the wire. Fields are kept
 * in lockstep with the Go struct; see internal/recordings/models.go for the
 * authoritative shape.
 *
 * @generated from message lvdr.v2.recordings.Recording
 */
export type Recording = Message<"lvdr.v2.recordings.Recording"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;

  /**
   * @generated from field: string owner_id = 2;
   */
  ownerId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string source_url = 5;
   */
  sourceUrl: string;

  /**
   * @generated from field: string original_name = 6;
   */
  originalName: string;

  /**
   * @generated from field: string mime = 7;
   */
  mime: string;

  /**
   * @generated from field: double duration_secs = 8;
   */
  durationSecs: number;

  /**
   * @generated from field: int64 size_bytes = 9;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string status = 10;
   */
  status: string;

  /**
   * @generated from field: string failure_reason = 11;
   */
  failureReason: string;

  /**
   * @generated from field: lvdr.v2.recordings.Transcript transcript = 12;
   */
  transcript?: Transcript | undefined;

  /**
   * @generated from field: repeated string speakers = 13;
   */
  speakers: string[];

  /**
   * @generated from field: repeated string tags = 14;
   */
  tags: string[];

  /**
   * @generated from field: string collection_id = 15;
   */
  collectionId: string;

  /**
   * @generated from field: string promoted_doc_id = 16;
   */
  promotedDocId: string;

  /**
   * @generated from field: string asr_model = 17;
   */
  asrModel: string;

  /**
   * @generated from field: double cost_usd = 18;
   */
  costUsd: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 19;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * R22 agentic ambient capture. auto_act_opt_in is the per-recording privacy
   * consent: when true (and the agentic_capture feature flag is on), a completed
   * transcription fires the recording-completed workflow trigger. auto_act_workflows
   * is server-set (read-only on the wire) — the workflow IDs that acted on this
   * recording, rendered by the FE as the "acted on by …" link-back.
   *
   * @generated from field: bool auto_act_opt_in = 21;
   */
  autoActOptIn: boolean;

  /**
   * @generated from field: repeated string auto_act_workflows = 22;
   */
  autoActWorkflows: string[];

  /**
   * cost_credits is the user-facing presentation of cost_usd: the transcription
   * cost converted to credits server-side via the shared billing pricing
   * (credits = USD × CreditsPerDollar × (1+Margin)). The product surfaces credits
   * exclusively — the FE renders this, never cost_usd. 0 when billing pricing is
   * unwired (degrades to "—" rather than leaking a dollar figure).
   *
   * @generated from field: int64 cost_credits = 23;
   */
  costCredits: bigint;

  /**
   * self_speaker_label is the diarized cluster label (e.g. "Speaker 2") that
   * speaker-recognition matched to the account holder's voiceprint, or "" when
   * none matched / the feature is off. The FE renders the user's current login
   * display name + a "you · auto" badge wherever segment.speaker == this. Not
   * biometric (a label pointer) — safe on the plaintext recording/proto.
   *
   * @generated from field: string self_speaker_label = 24;
   */
  selfSpeakerLabel: string;
};

/**
 * Describes the message lvdr.v2.recordings.Recording.
 * Use `create(RecordingSchema)` to create a new message.
 */
export const RecordingSchema: GenMessage<Recording> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 2);

/**
 * @generated from message lvdr.v2.recordings.ListRecordingsRequest
 */
export type ListRecordingsRequest = Message<"lvdr.v2.recordings.ListRecordingsRequest"> & {
};

/**
 * Describes the message lvdr.v2.recordings.ListRecordingsRequest.
 * Use `create(ListRecordingsRequestSchema)` to create a new message.
 */
export const ListRecordingsRequestSchema: GenMessage<ListRecordingsRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 3);

/**
 * @generated from message lvdr.v2.recordings.ListRecordingsResponse
 */
export type ListRecordingsResponse = Message<"lvdr.v2.recordings.ListRecordingsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.recordings.Recording recordings = 1;
   */
  recordings: Recording[];
};

/**
 * Describes the message lvdr.v2.recordings.ListRecordingsResponse.
 * Use `create(ListRecordingsResponseSchema)` to create a new message.
 */
export const ListRecordingsResponseSchema: GenMessage<ListRecordingsResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 4);

/**
 * @generated from message lvdr.v2.recordings.GetRecordingRequest
 */
export type GetRecordingRequest = Message<"lvdr.v2.recordings.GetRecordingRequest"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;
};

/**
 * Describes the message lvdr.v2.recordings.GetRecordingRequest.
 * Use `create(GetRecordingRequestSchema)` to create a new message.
 */
export const GetRecordingRequestSchema: GenMessage<GetRecordingRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 5);

/**
 * @generated from message lvdr.v2.recordings.GetRecordingResponse
 */
export type GetRecordingResponse = Message<"lvdr.v2.recordings.GetRecordingResponse"> & {
  /**
   * @generated from field: lvdr.v2.recordings.Recording recording = 1;
   */
  recording?: Recording | undefined;
};

/**
 * Describes the message lvdr.v2.recordings.GetRecordingResponse.
 * Use `create(GetRecordingResponseSchema)` to create a new message.
 */
export const GetRecordingResponseSchema: GenMessage<GetRecordingResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 6);

/**
 * UpdateRecordingRequest follows the protobuf-empty-string rule (CLAUDE.md:
 * "Protobuf empty strings erase fields"). Scalar string fields use proto3
 * `optional` so the handler can distinguish "not set" from "set to empty
 * string" and populate unchanged fields from the current row.
 *
 * Repeated fields don't support `optional` in proto3; for v1 we adopt the
 * pragmatic rule: nil / empty `tags` / `speakers` means "don't change". A
 * deliberate clear is not yet expressible — callers wanting to wipe must
 * pass a single-element slice and accept the convention. Revisit when a UI
 * flow needs explicit clear.
 *
 * @generated from message lvdr.v2.recordings.UpdateRecordingRequest
 */
export type UpdateRecordingRequest = Message<"lvdr.v2.recordings.UpdateRecordingRequest"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string | undefined;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[];

  /**
   * @generated from field: repeated string speakers = 4;
   */
  speakers: string[];

  /**
   * @generated from field: optional string collection_id = 5;
   */
  collectionId?: string | undefined;

  /**
   * R22: per-recording agentic-capture opt-in. optional so "not set" leaves the
   * current value unchanged (protobuf-empty-string rule for scalars).
   *
   * @generated from field: optional bool auto_act_opt_in = 6;
   */
  autoActOptIn?: boolean | undefined;
};

/**
 * Describes the message lvdr.v2.recordings.UpdateRecordingRequest.
 * Use `create(UpdateRecordingRequestSchema)` to create a new message.
 */
export const UpdateRecordingRequestSchema: GenMessage<UpdateRecordingRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 7);

/**
 * @generated from message lvdr.v2.recordings.UpdateRecordingResponse
 */
export type UpdateRecordingResponse = Message<"lvdr.v2.recordings.UpdateRecordingResponse"> & {
  /**
   * @generated from field: lvdr.v2.recordings.Recording recording = 1;
   */
  recording?: Recording | undefined;
};

/**
 * Describes the message lvdr.v2.recordings.UpdateRecordingResponse.
 * Use `create(UpdateRecordingResponseSchema)` to create a new message.
 */
export const UpdateRecordingResponseSchema: GenMessage<UpdateRecordingResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 8);

/**
 * @generated from message lvdr.v2.recordings.DeleteRecordingRequest
 */
export type DeleteRecordingRequest = Message<"lvdr.v2.recordings.DeleteRecordingRequest"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;
};

/**
 * Describes the message lvdr.v2.recordings.DeleteRecordingRequest.
 * Use `create(DeleteRecordingRequestSchema)` to create a new message.
 */
export const DeleteRecordingRequestSchema: GenMessage<DeleteRecordingRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 9);

/**
 * @generated from message lvdr.v2.recordings.DeleteRecordingResponse
 */
export type DeleteRecordingResponse = Message<"lvdr.v2.recordings.DeleteRecordingResponse"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;
};

/**
 * Describes the message lvdr.v2.recordings.DeleteRecordingResponse.
 * Use `create(DeleteRecordingResponseSchema)` to create a new message.
 */
export const DeleteRecordingResponseSchema: GenMessage<DeleteRecordingResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 10);

/**
 * @generated from message lvdr.v2.recordings.RetryTranscriptionRequest
 */
export type RetryTranscriptionRequest = Message<"lvdr.v2.recordings.RetryTranscriptionRequest"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;
};

/**
 * Describes the message lvdr.v2.recordings.RetryTranscriptionRequest.
 * Use `create(RetryTranscriptionRequestSchema)` to create a new message.
 */
export const RetryTranscriptionRequestSchema: GenMessage<RetryTranscriptionRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 11);

/**
 * @generated from message lvdr.v2.recordings.RetryTranscriptionResponse
 */
export type RetryTranscriptionResponse = Message<"lvdr.v2.recordings.RetryTranscriptionResponse"> & {
  /**
   * @generated from field: lvdr.v2.recordings.Recording recording = 1;
   */
  recording?: Recording | undefined;
};

/**
 * Describes the message lvdr.v2.recordings.RetryTranscriptionResponse.
 * Use `create(RetryTranscriptionResponseSchema)` to create a new message.
 */
export const RetryTranscriptionResponseSchema: GenMessage<RetryTranscriptionResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 12);

/**
 * CancelTranscriptionRequest stops an in-flight transcription (REC-CANCEL-01).
 * Accepted only from the mid-flight statuses (pending / extracting /
 * transcribing); the recording lands in the terminal `cancelled` status, which
 * a later RetryTranscription may leave again.
 *
 * @generated from message lvdr.v2.recordings.CancelTranscriptionRequest
 */
export type CancelTranscriptionRequest = Message<"lvdr.v2.recordings.CancelTranscriptionRequest"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;
};

/**
 * Describes the message lvdr.v2.recordings.CancelTranscriptionRequest.
 * Use `create(CancelTranscriptionRequestSchema)` to create a new message.
 */
export const CancelTranscriptionRequestSchema: GenMessage<CancelTranscriptionRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 13);

/**
 * @generated from message lvdr.v2.recordings.CancelTranscriptionResponse
 */
export type CancelTranscriptionResponse = Message<"lvdr.v2.recordings.CancelTranscriptionResponse"> & {
  /**
   * @generated from field: lvdr.v2.recordings.Recording recording = 1;
   */
  recording?: Recording | undefined;
};

/**
 * Describes the message lvdr.v2.recordings.CancelTranscriptionResponse.
 * Use `create(CancelTranscriptionResponseSchema)` to create a new message.
 */
export const CancelTranscriptionResponseSchema: GenMessage<CancelTranscriptionResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 14);

/**
 * @generated from message lvdr.v2.recordings.PromoteRecordingRequest
 */
export type PromoteRecordingRequest = Message<"lvdr.v2.recordings.PromoteRecordingRequest"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;
};

/**
 * Describes the message lvdr.v2.recordings.PromoteRecordingRequest.
 * Use `create(PromoteRecordingRequestSchema)` to create a new message.
 */
export const PromoteRecordingRequestSchema: GenMessage<PromoteRecordingRequest> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 15);

/**
 * @generated from message lvdr.v2.recordings.PromoteRecordingResponse
 */
export type PromoteRecordingResponse = Message<"lvdr.v2.recordings.PromoteRecordingResponse"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message lvdr.v2.recordings.PromoteRecordingResponse.
 * Use `create(PromoteRecordingResponseSchema)` to create a new message.
 */
export const PromoteRecordingResponseSchema: GenMessage<PromoteRecordingResponse> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 16);

/**
 * RecordingStatusEvent is server-pushed when a recording's status changes
 * (transcribing → ready / failed). The Service-level event callback (set by
 * B14 wiring) emits this as a broadcast to the owning user's connections.
 *
 * @generated from message lvdr.v2.recordings.RecordingStatusEvent
 */
export type RecordingStatusEvent = Message<"lvdr.v2.recordings.RecordingStatusEvent"> & {
  /**
   * @generated from field: string recording_id = 1;
   */
  recordingId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string failure_reason = 3;
   */
  failureReason: string;
};

/**
 * Describes the message lvdr.v2.recordings.RecordingStatusEvent.
 * Use `create(RecordingStatusEventSchema)` to create a new message.
 */
export const RecordingStatusEventSchema: GenMessage<RecordingStatusEvent> = /*@__PURE__*/
  messageDesc(file_recordings_recordings, 17);

